import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";
import DriveEndType from "../../../../enums/drive-end-type";

/**
 * Rule for a missed Deuce (Indoor Football).
 * After a missed Deuce, the receiving team gets possession
 * at the kicked-to spot (where the ball landed).
 */
export default class DeuceMissed extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.DeuceMissed;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { homeTeamId, awayTeamId } = gameContext;

        // Get the kickoff info to determine receiving team and kicked-to spot
        const kickOffFragment =
            play.getFirstFragment(FootballState.KickOff) || {};
        const { kickedTo } = kickOffFragment;
        const { kickedBy } = play.getFirstFragment(FootballState.Kick) || {};
        const kickingTeamId = kickedBy?.teamId;
        const receivingTeamId =
            kickingTeamId === homeTeamId ? awayTeamId : homeTeamId;

        // Receiving team gets the ball at the kicked-to spot
        gameContext.setPossessionForTeamId(receivingTeamId);
        gameContext.setFieldPosition(kickedTo);
        ruleContext.setAwardFirstDown(true);

        // A deuce is a kickoff outcome: the receiving team takes over, so a new
        // drive must be cut for them (mirror Turnover/KickOff). Without this the
        // receiver inherits the kicking team's drive.
        gameContext.setDriveContext({
            ...gameContext.getDriveContext(),
            previousDriveEndType: DriveEndType.Deuce,
            triggerDrive: true
        });
        gameContext.currentDriveId = null;
    }
}
